import { Flow_0_0_2 } from '@flexus/core';

export const BUI_91: Flow_0_0_2 = {
	id: '91',
	name: 'assessor_query',
	itemType: 'flow',
	header: {
		title: '',
		controls: () => () => []
	},
	footer: {
		type: 'node_nav'
	},
	instructions: {
		editRoles: {
			0: '--'
		},
		viewRoles: {
			0: 'Wait for SP response'
		}
	},
	startNode: '',
	nodes: {}
};
